import { createImageIconComponent } from './library'

export const IconPerson = createImageIconComponent(
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" style={{ height: '1em' }}>
    <path
      fill="currentColor"
      d="M96 0c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64S60.7 0 96 0m48 144h-11.4c-22.7 10.4-49.6 10.9-73.3 0H48c-26.5 0-48 21.5-48 48v136c0 13.3 10.7 24 24 24h16v136c0 13.3 10.7 24 24 24h64c13.3 0 24-10.7 24-24V352h16c13.3 0 24-10.7 24-24V192c0-26.5-21.5-48-48-48z"
    />
  </svg>
)
